import React from 'react';
import styles from './Divider.less';

export default function ({ label }) {
  return <span className={styles.divider}>{label}</span>;
}
